/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
export class ToastsProvider {
    constructor() {
        this.config = {
            animation: true
        };
    }
    $get() {
        return this.config;
    }
}
